/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { MerchantDTO } from "./MerchantDTO";
import { MerchantDTOFromJSON, MerchantDTOFromJSONTyped, MerchantDTOToJSON } from "./MerchantDTO";
import type { PlatformRefDTO } from "./PlatformRefDTO";
import { PlatformRefDTOFromJSON, PlatformRefDTOFromJSONTyped, PlatformRefDTOToJSON } from "./PlatformRefDTO";

/**
 *
 * @export
 * @interface CreateFeaturedCategoriesDTO
 */
export interface CreateFeaturedCategoriesDTO {
  /**
   *
   * @type {PlatformRefDTO}
   * @memberof CreateFeaturedCategoriesDTO
   */
  platform: PlatformRefDTO;
  /**
   *
   * @type {MerchantDTO}
   * @memberof CreateFeaturedCategoriesDTO
   */
  merchant: MerchantDTO;
  /**
   *
   * @type {string}
   * @memberof CreateFeaturedCategoriesDTO
   */
  categoryTitle: string;
  /**
   *
   * @type {string}
   * @memberof CreateFeaturedCategoriesDTO
   */
  trackingUrl: string;
  /**
   *
   * @type {string}
   * @memberof CreateFeaturedCategoriesDTO
   */
  slug: string;
}

/**
 * Check if a given object implements the CreateFeaturedCategoriesDTO interface.
 */
export function instanceOfCreateFeaturedCategoriesDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "merchant" in value;
  isInstance = isInstance && "categoryTitle" in value;
  isInstance = isInstance && "trackingUrl" in value;
  isInstance = isInstance && "slug" in value;

  return isInstance;
}

export function CreateFeaturedCategoriesDTOFromJSON(json: any): CreateFeaturedCategoriesDTO {
  return CreateFeaturedCategoriesDTOFromJSONTyped(json, false);
}

export function CreateFeaturedCategoriesDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateFeaturedCategoriesDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    platform: PlatformRefDTOFromJSON(json["platform"]),
    merchant: MerchantDTOFromJSON(json["merchant"]),
    categoryTitle: json["categoryTitle"],
    trackingUrl: json["trackingUrl"],
    slug: json["slug"]
  };
}

export function CreateFeaturedCategoriesDTOToJSON(value?: CreateFeaturedCategoriesDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    platform: PlatformRefDTOToJSON(value.platform),
    merchant: MerchantDTOToJSON(value.merchant),
    categoryTitle: value.categoryTitle,
    trackingUrl: value.trackingUrl,
    slug: value.slug
  };
}
